<template><section><h1>Loading</h1>
<blockquote>
<p>加载条</p>
</blockquote>
<h2>代码示例</h2>
<p><test></test></p>

<h2>API</h2>
<pre><code class="language-js"><span class="hljs-keyword">this</span>.$loading.start()
<span class="hljs-keyword">this</span>.$loading.success()
<span class="hljs-keyword">this</span>.$loading.error()
</code></pre>
<h2>Params</h2>
<table>
<thead>
<tr>
<th>参数</th>
<th style="text-align:left">说明</th>
<th>类型</th>
<th>默认值</th>
</tr>
</thead>
<tbody>
<tr>
<td>name</td>
<td style="text-align:left">description</td>
<td><code>String</code></td>
<td>-</td>
</tr>
</tbody>
</table>
</section></template>

<script>
  import test from '@/pages/demo/Loading.vue';

  export default {
    components: {
      test
    }
  }
</script>


// WEBPACK FOOTER //
// index-6.vue?8de24332